import { render, staticRenderFns } from "./TpassReceiptDetail.vue?vue&type=template&id=f490c45c&scoped=true&"
import script from "./TpassReceiptDetail.vue?vue&type=script&lang=js&"
export * from "./TpassReceiptDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f490c45c",
  null
  
)

export default component.exports